import { render, staticRenderFns } from "./index.vue?vue&type=template&id=621b7e78&"
import script from "./quiz.js?vue&type=script&lang=js&"
export * from "./quiz.js?vue&type=script&lang=js&"
import style0 from "./quiz.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports